import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@pinpoint/design-kit';
import DefaultTheme from 'src/styles/DefaultTheme';

const StyledButton = styled(Button)`
  :active {
    background-color: ${({ disabled }) => (!disabled ? DefaultTheme.colors.blue : '')};
  }
`;

function PrimaryButton({ children, ...userProps }) {
  return (
    <StyledButton bg="blue" hoverBg="blueLight" m={{ r: '0.5rem' }} p={{ x: '0.75rem' }} h="1.875rem" {...userProps}>
      {children}
    </StyledButton>
  );
}

PrimaryButton.defaultProps = {
  children: null,
};

PrimaryButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default PrimaryButton;
